import React from 'react';

export default function GalaxyCloakSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="galaxyGrad" x1="0" y1="0" x2="0.7" y2="1">
          <stop offset="0%" stopColor="#311B92" />
          <stop offset="55%" stopColor="#1A237E" />
          <stop offset="100%" stopColor="#0D1340" />
        </linearGradient>
        <radialGradient id="nebula" cx="0.5" cy="0.6" r="0.5">
          <stop offset="0%" stopColor="#7C4DFF" stopOpacity="0.5" />
          <stop offset="100%" stopColor="#7C4DFF" stopOpacity="0" />
        </radialGradient>
      </defs>
      {/* Cloak body */}
      <path d="M11 8 C9 12 6 24 7 36 C12 34 16 36 20 35 C24 36 28 34 33 36 C34 24 31 12 29 8 Z" fill="url(#galaxyGrad)" />
      {/* Subtle nebula glow */}
      <ellipse cx="20" cy="24" rx="10" ry="8" fill="url(#nebula)" />
      {/* Collar */}
      <ellipse cx="20" cy="9" rx="9" ry="2.5" fill="#1A237E" />
      <ellipse cx="20" cy="8.5" rx="8" ry="1.5" fill="#283593" />
      {/* Stars - varying sizes */}
      <circle cx="13" cy="14" r="0.7" fill="white" />
      <circle cx="17" cy="18" r="0.4" fill="white" opacity="0.8" />
      <circle cx="23" cy="14" r="0.5" fill="white" opacity="0.9" />
      <circle cx="27" cy="20" r="0.7" fill="white" />
      <circle cx="11" cy="22" r="0.4" fill="white" opacity="0.7" />
      <circle cx="20" cy="22" r="0.9" fill="white" />
      <circle cx="29" cy="26" r="0.5" fill="white" opacity="0.8" />
      <circle cx="14" cy="28" r="0.6" fill="white" opacity="0.85" />
      <circle cx="22" cy="28" r="0.4" fill="white" opacity="0.7" />
      <circle cx="18" cy="32" r="0.5" fill="white" opacity="0.8" />
      <circle cx="26" cy="32" r="0.4" fill="white" opacity="0.6" />
      <circle cx="10" cy="30" r="0.3" fill="white" opacity="0.6" />
      {/* Star sparkle (4-pointed) */}
      <path d="M20 22 L20 24 M20 22 L20 20 M20 22 L22 22 M20 22 L18 22" stroke="white" strokeWidth="0.4" opacity="0.8" />
      {/* Gold clasp */}
      <circle cx="20" cy="8.5" r="1.5" fill="#FFD54F" />
      <circle cx="20" cy="8.5" r="0.6" fill="#FF8F00" />
    </svg>
  );
}
